import request from '@/utils/request'
const wxAppApi = {
  queryItemInfo: (params) => {
    return request({
      url: `/order/info/${params.orderId}`,
      method: 'get'
    })
  },
  policyList: (params) => {
    return request({
      url: `/privacy/policy/list`,
      method: 'get'
    })
  },
  policyInfo: (params) => {
    return request({
      url: `/privacy/policy/info/${params.id}`,
      method: 'get'
    })
  },
  queryLogisticsList: (params) => {
    return request({
      url: '/order/logistics/query',
      method: 'get',
      params
    })
  },
  getCassLoginHelpImg: (data) => {
    return request({
      url: '/public/apply/image',
      method: 'post',
      data
    })
  },
  // 登录 注册
  authLoginClientQuery: (data) => {
    return request({
      url: '/auth/login-client/query',
      method: 'post',
      data
    })
  },
  authLogin: (data) => {
    return request({
      url: '/auth/login',
      method: 'post',
      data
    })
  },
  isNeedUpdatePassword: (data) => {
    return request({
      url: '/client/isNeedUpdatePassword',
      method: 'get',
      data
    })
  }
}

export default wxAppApi
